import { useSoyuzData } from '@spotahome/soyuz/client';
import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner
} from '@spotahome/ui-library';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import { getInstitutionData } from '@spotahome/landings-common/src/api/real-estate-client';
import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';

import Institution from './components/Institution';

const requester = (() => {
  let instance;
  let params = {};

  function sameParams(domain, pageName, locale) {
    return (
      params.domain === domain &&
      params.pageName === pageName &&
      params.locale === locale
    );
  }

  function saveInstance(domain, pageName, locale) {
    instance = getInstitutionData(domain, pageName, locale);
    params = { domain, pageName, locale };
    return instance;
  }

  return (domain, pageName, locale) => {
    const instanceToReturn =
      (sameParams(domain, pageName, locale) && instance) ||
      saveInstance(domain, pageName, locale);

    return instanceToReturn.then(response => {
      instance = null;
      return response;
    });
  };
})();

const InstitutionContainer = () => {
  const { [InstitutionContainer.NAME]: requestedData } = useSoyuzData();
  const { initialCookie, institution, deviceType, deviceViewType, userId } =
    requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <AppBanner source="home" deviceType={deviceType} />
          {!userId && <GoogleOneTap />}
          <Institution data={institution} />
          <LazyLoginSignUpModal deviceViewType={deviceViewType} />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

InstitutionContainer.requestHeaders = async (req, domain = '') => {
  const pageName = req.path.split('/').filter(Boolean).reverse()[0];
  const { data } = await requester(domain, pageName, req.locale);
  return {
    title: data.metaTitle,
    metas: [
      { name: 'title', content: data.metaTitle },
      { name: 'description', content: data.metaDescription },
      { property: 'og:title', content: data.metaTitle },
      { property: 'og:description', content: data.metaDescription },
      {
        property: 'og:url',
        content: `https://www.spotahome.com/${data.ID}`
      },
      { name: 'twitter:title', content: data.metaTitle },
      { name: 'twitter:description', content: data.metaDescription },
      {
        name: 'twitter:url',
        content: `https://www.spotahome.com/${data.ID}`
      }
    ]
  };
};

InstitutionContainer.requestData = async (req, domain = '') => {
  const pageName = req.path.split('/').filter(Boolean).reverse()[0];
  const response = await requester(domain, pageName, req.locale);

  return {
    data: {
      institution: response.data,
      deviceType: req.device.type,
      deviceViewType: req.device.viewType,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

InstitutionContainer.NAME = 'InstitutionContainer';

export default InstitutionContainer;
